'use strict';

import angular from 'angular';
import Categorie from './categories.controller';

export default angular.module('aperamApp.borne.categories', [])
  .controller('CategoriesController', Categorie)
  .name;


// WEBPACK FOOTER //
// ./client/app/borne/categories/index.js